import { useState, useEffect, useRef } from "react";
import { io } from "socket.io-client";

const nearbyAlerts = []; // Echte meldingen komen van de backend

const fakeCalls = [
  { name:"Mama",    emoji:"👩", duration:"2:34" },
  { name:"Sara",    emoji:"👧", duration:"1:12" },
  { name:"Lena",    emoji:"👩‍🦱", duration:"3:05" },
  { name:"Politie", emoji:"👮", duration:"0:45" },
];

function PulsingDot({ color="#22c55e" }) {
  return (
    <span style={{position:"relative",display:"inline-flex",alignItems:"center",justifyContent:"center"}}>
      <span style={{position:"absolute",width:16,height:16,borderRadius:"50%",background:color,opacity:0.35,animation:"ping 1.5s cubic-bezier(0,0,0.2,1) infinite"}}/>
      <span style={{width:8,height:8,borderRadius:"50%",background:color,position:"relative"}}/>
    </span>
  );
}

export default function GetHomeSafeApp() {
  const [screen, setScreen]           = useState("onboarding");
  const [prevScreen, setPrevScreen]   = useState(null);
  const [signupStep, setSignupStep]   = useState(1);
  const [geslacht, setGeslacht]       = useState("vrouw"); // vrouw | man
  const [friendsList, setFriendsList] = useState([]);      // vrienden uit de groep
  const socketRef = useRef(null);
  const friendAlarmRef = useRef(null);
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);
  const [onlineUserIds, setOnlineUserIds] = useState([]);
  const [friendAlert, setFriendAlert] = useState(null);
  const [friendLocation, setFriendLocation] = useState(null);
  const [friendSafe, setFriendSafe] = useState(null);
  const [groupLocations, setGroupLocations] = useState([]); // Live locaties van groepsleden
  const [leafletLoaded, setLeafletLoaded] = useState(false);

  // Thema op basis van geslacht
  const T = geslacht === "man" ? {
    primary:   "#2563eb",
    accent:    "#3b82f6",
    soft:      "rgba(37,99,235,.15)",
    border:    "rgba(37,99,235,.3)",
    gradient:  "linear-gradient(135deg,#1e3a8a,#2563eb)",
    bg:        "#060d1a",
    card:      "#0a1628",
    cardBorder:"#1e3a5f",
    sub:       "#60a5fa",
    nav:       "#0a1628",
    tabActive: "#3b82f6",
    friendBg:  "rgba(37,99,235,.1)",
  } : {
    primary:   "#db2777",
    accent:    "#ec4899",
    soft:      "rgba(236,72,153,.15)",
    border:    "rgba(236,72,153,.3)",
    gradient:  "linear-gradient(135deg,#9d174d,#ec4899)",
    bg:        "#0f0a10",
    card:      "#1a0d18",
    cardBorder:"#3d1a35",
    sub:       "#f9a8d4",
    nav:       "#1a0d18",
    tabActive: "#ec4899",
    friendBg:  "rgba(236,72,153,.1)",
  };
  const [friendSlots, setFriendSlots] = useState([{email:"",geslacht:"vrouw"},{email:"",geslacht:"vrouw"},{email:"",geslacht:"vrouw"},{email:"",geslacht:"vrouw"},{email:"",geslacht:"vrouw"}]);
  const [signupData, setSignupData]   = useState({naam:"",email:"",telefoon:"",wachtwoord:""});
  const [signupErrors, setSignupErrors] = useState({});
  const [paying, setPaying]           = useState(false);
  const [safeHomeTime, setSafeHomeTime] = useState("");
  const [time, setTime]               = useState("");
  const [timerActive, setTimerActive] = useState(false);
  const [timerMins, setTimerMins]     = useState(15);
  const [timerLeft, setTimerLeft]     = useState(null);
  const [fakeCallActive, setFakeCallActive] = useState(false);
  const [fakeCallPerson, setFakeCallPerson] = useState(fakeCalls[0]);
  const [fakeCallState, setFakeCallState]   = useState("ringing"); // ringing | active
  const [fakeCallElapsed, setFakeCallElapsed] = useState(0);
  const [nearbyAlert, setNearbyAlert] = useState(false);
  const [profileName, setProfileName] = useState("Jouw naam");
  const [editProfile, setEditProfile] = useState(false);
  const [groepscode, setGroepscode]   = useState("");
  const [instellingen, setInstellingen] = useState({pushNotif:true, buurtMeld:true, privacy:false, donker:true});         // eigen code als betaler
  const [invoerCode, setInvoerCode]   = useState("");         // code invullen als vriend
  const [codeCheck, setCodeCheck]     = useState(null);       // {eigenaar_naam, vrije_plekken}
  const [codeStatus, setCodeStatus]   = useState("idle");     // idle | checking | valid | invalid
  const [activeTab, setActiveTab]     = useState("home");
  const [joinWithCode, setJoinWithCode] = useState(false);    // registreren met code (gratis)

  // GPS
  const [gpsLat, setGpsLat]         = useState(null);
  const [gpsLng, setGpsLng]         = useState(null);
  const [gpsAddress, setGpsAddress] = useState("Locatie ophalen...");
  const [gpsStatus, setGpsStatus]   = useState("loading"); // loading | active | denied
  const gpsWatchRef = useRef(null);

  // ── API & AUTH ──
  const [apiToken, setApiToken]     = useState(() => localStorage.getItem("ghs_token") || null);
  const [apiUser, setApiUser]       = useState(() => { try { return JSON.parse(localStorage.getItem("ghs_user")); } catch { return null; } });
  const [apiLoading, setApiLoading] = useState(false);
  const [apiError, setApiError]     = useState("");

  const api = async (path, opts={}) => {
    const headers = { "Content-Type": "application/json" };
    if (apiToken) headers["Authorization"] = `Bearer ${apiToken}`;
    const r = await fetch(path, { ...opts, headers: { ...headers, ...opts.headers } });
    const d = await r.json();
    if (!r.ok) throw new Error(d.error || "Server fout");
    return d;
  };

  const login = (token, user) => {
    localStorage.setItem("ghs_token", token);
    localStorage.setItem("ghs_user", JSON.stringify(user));
    setApiToken(token);
    setApiUser(user);
  };

  const logout = () => {
    localStorage.removeItem("ghs_token");
    localStorage.removeItem("ghs_user");
    setApiToken(null);
    setApiUser(null);
    setScreen("onboarding");
    setActiveTab("home");
  };

  // Auto-login als token al bestaat
  useEffect(() => {
    if (apiToken && apiUser) setScreen("home");
  }, []);

  // Synchroniseer profileName met apiUser.naam
  useEffect(() => {
    if (apiUser?.naam) {
      setProfileName(apiUser.naam);
    }
  }, [apiUser]);

  // Laad profiel (inclusief groepscode) bij login
  useEffect(() => {
    if (apiToken) {
      api("/api/profiel")
        .then(profiel => {
          if (profiel?.groepscode) setGroepscode(profiel.groepscode);
          if (profiel?.naam) setProfileName(profiel.naam);
          if (profiel?.vrienden) setFriendsList(profiel.vrienden.map(v => ({id: v.id, name: v.naam, email: v.email, geslacht: v.geslacht, avatar: v.naam?.charAt(0).toUpperCase()})));
        })
        .catch(err => console.log("Profiel laden mislukt:", err.message));
    }
  }, [apiToken]);

  // WebSocket verbinding voor online status
  useEffect(() => {
    if (apiToken) {
      socketRef.current = io(window.location.origin, { withCredentials: true });
      
      socketRef.current.on("connect", () => {
        console.log("🔌 WebSocket verbonden");
        socketRef.current.emit("login", apiToken);
      });
      
      socketRef.current.on("online_users", (userIds) => {
        setOnlineUserIds(userIds);
      });
      
      socketRef.current.on("user_online", (userId) => {
        setOnlineUserIds(prev => [...new Set([...prev, userId])]);
      });
      
      socketRef.current.on("user_offline", (userId) => {
        setOnlineUserIds(prev => prev.filter(id => id !== userId));
      });
      
      socketRef.current.on("friend_alert", (data) => {
        console.log("🚨 ALERT van vriend:", data);
        setFriendAlert(data);
        // Start continu alarm geluid (zelfde als noodknop)
        playAlarm();
        friendAlarmRef.current = setInterval(playAlarm, 700);
        // Browser notificatie
        if (Notification.permission === "granted") {
          new Notification("🚨 " + data.naam + " heeft hulp nodig!", {
            body: data.address || "Locatie onbekend",
            icon: "/icons/icon-192.png",
            tag: "friend-alert"
          });
        }
      });
      
      socketRef.current.on("friend_location", (data) => {
        console.log("📍 Locatie van vriend:", data);
        setFriendLocation(data);
        playNotification();
        setTimeout(() => setFriendLocation(null), 5000); // Auto-hide na 5 sec
        if (Notification.permission === "granted") {
          new Notification("📍 " + data.naam + " deelt locatie", {
            body: data.address || "Locatie onbekend",
            icon: "/icons/icon-192.png"
          });
        }
      });
      
      socketRef.current.on("friend_safe", (data) => {
        console.log("🏠 Vriend veilig thuis:", data);
        setFriendSafe(data);
        playNotification();
        // Geen auto-hide - blijft staan tot gebruiker klikt
        if (Notification.permission === "granted") {
          new Notification("🏠 " + data.naam + " is veilig thuis!", {
            body: "Aangekomen om " + data.time,
            icon: "/icons/icon-192.png"
          });
        }
      });
      
      socketRef.current.on("alert_dismissed", (data) => {
        console.log("✅ Alert opgeheven door:", data.naam);
        setFriendAlert(null);
        // Stop alarm geluid
        if (friendAlarmRef.current) {
          clearInterval(friendAlarmRef.current);
          friendAlarmRef.current = null;
        }
      });
      
      // Live locatie updates van groepsleden
      socketRef.current.on("friend_location_update", (data) => {
        setGroupLocations(prev => {
          const filtered = prev.filter(loc => loc.oderId !== data.oderId);
          return [...filtered, data];
        });
      });
      
      // Alle groepslocaties ontvangen
      socketRef.current.on("group_locations", (locations) => {
        setGroupLocations(locations);
      });
      
      // Vraag groepslocaties op bij connect
      socketRef.current.emit("get_group_locations");
      
      return () => {
        if (socketRef.current) socketRef.current.disconnect();
        if (friendAlarmRef.current) { clearInterval(friendAlarmRef.current); friendAlarmRef.current = null; }
      };
    }
  }, [apiToken]);

  // Live locatie delen met groep (elke 10 sec)
  useEffect(() => {
    if (apiToken && socketRef.current && gpsStatus === "active" && gpsLat && gpsLng) {
      // Direct sturen bij eerste keer
      socketRef.current.emit("location_update", { lat: gpsLat, lng: gpsLng, address: gpsAddress });
      
      const interval = setInterval(() => {
        if (socketRef.current && gpsLat && gpsLng) {
          socketRef.current.emit("location_update", { lat: gpsLat, lng: gpsLng, address: gpsAddress });
        }
      }, 10000); // elke 10 seconden
      
      return () => clearInterval(interval);
    }
  }, [apiToken, gpsStatus, gpsLat, gpsLng]);

  // Leaflet laden
  useEffect(() => {
    if (!document.getElementById('leaflet-css')) {
      const css = document.createElement('link');
      css.id = 'leaflet-css';
      css.rel = 'stylesheet';
      css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
    }
    if (!window.L && !document.getElementById('leaflet-js')) {
      const script = document.createElement('script');
      script.id = 'leaflet-js';
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.onload = () => setLeafletLoaded(true);
      document.head.appendChild(script);
    } else if (window.L) {
      setLeafletLoaded(true);
    }
  }, []);

  // Kaart initialiseren en updaten
  useEffect(() => {
    if (!leafletLoaded || !window.L || screen !== "map" || !gpsLat || !gpsLng) return;
    
    // Wacht tot DOM klaar is
    setTimeout(() => {
      const mapContainer = document.getElementById('leaflet-map');
      if (!mapContainer) return;
      
      // Check of bestaande kaart nog geldig is
      if (mapInstanceRef.current) {
        try {
          // Test of de kaart nog werkt
          mapInstanceRef.current.getCenter();
        } catch (e) {
          // Kaart is ongeldig, reset
          mapInstanceRef.current = null;
          markersRef.current = [];
        }
      }
      
      // Als kaart al bestaat, update alleen markers
      if (mapInstanceRef.current) {
        // Verwijder oude markers
        markersRef.current.forEach(m => m.remove());
        markersRef.current = [];
        
        // Voeg nieuwe markers toe
        const myIcon = window.L.divIcon({
          className: 'custom-marker',
          html: `<div style="background:linear-gradient(135deg,#22c55e,#16a34a);width:32px;height:32px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;font-size:14px;">📍</div>`,
          iconSize: [32, 32],
          iconAnchor: [16, 32]
        });
        
        const myMarker = window.L.marker([gpsLat, gpsLng], {icon: myIcon})
          .addTo(mapInstanceRef.current)
          .bindPopup(`<b>📍 Jij</b><br>${gpsAddress || 'Jouw locatie'}`);
        markersRef.current.push(myMarker);
        
        // Groepsleden markers
        groupLocations.forEach(loc => {
          const friendIcon = window.L.divIcon({
            className: 'custom-marker',
            html: `<div style="background:linear-gradient(135deg,#6366f1,#8b5cf6);width:32px;height:32px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;font-weight:800;font-size:12px;color:white;">${loc.naam?.charAt(0)?.toUpperCase() || '?'}</div>`,
            iconSize: [32, 32],
            iconAnchor: [16, 32]
          });
          
          const marker = window.L.marker([loc.lat, loc.lng], {icon: friendIcon})
            .addTo(mapInstanceRef.current)
            .bindPopup(`<b>${loc.naam}</b><br>${loc.address || 'Locatie onbekend'}<br><small>${loc.timestamp ? new Date(loc.timestamp).toLocaleTimeString() : ''}</small>`);
          markersRef.current.push(marker);
        });
        
        // Zoom naar alle markers
        if (groupLocations.length > 0) {
          const allPoints = [[gpsLat, gpsLng], ...groupLocations.map(l => [l.lat, l.lng])];
          const bounds = window.L.latLngBounds(allPoints);
          mapInstanceRef.current.fitBounds(bounds, {padding: [30, 30]});
        } else {
          mapInstanceRef.current.setView([gpsLat, gpsLng], 15);
        }
        
        return;
      }
      
      // Nieuwe kaart maken
      const map = window.L.map(mapContainer).setView([gpsLat, gpsLng], 15);
      mapInstanceRef.current = map;
      
      // Fix voor container size issues
      setTimeout(() => map.invalidateSize(), 100);
      
      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(map);
      
      // Mijn marker
      const myIcon = window.L.divIcon({
        className: 'custom-marker',
        html: `<div style="background:linear-gradient(135deg,#22c55e,#16a34a);width:32px;height:32px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;font-size:14px;">📍</div>`,
        iconSize: [32, 32],
        iconAnchor: [16, 32]
      });
      
      const myMarker = window.L.marker([gpsLat, gpsLng], {icon: myIcon})
        .addTo(map)
        .bindPopup(`<b>📍 Jij</b><br>${gpsAddress || 'Jouw locatie'}`);
      markersRef.current.push(myMarker);
      
      // Groepsleden markers
      groupLocations.forEach(loc => {
        const friendIcon = window.L.divIcon({
          className: 'custom-marker',
          html: `<div style="background:linear-gradient(135deg,#6366f1,#8b5cf6);width:32px;height:32px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;font-weight:800;font-size:12px;color:white;">${loc.naam?.charAt(0)?.toUpperCase() || '?'}</div>`,
          iconSize: [32, 32],
          iconAnchor: [16, 32]
        });
        
        const marker = window.L.marker([loc.lat, loc.lng], {icon: friendIcon})
          .addTo(map)
          .bindPopup(`<b>${loc.naam}</b><br>${loc.address || 'Locatie onbekend'}<br><small>${loc.timestamp ? new Date(loc.timestamp).toLocaleTimeString() : ''}</small>`);
        markersRef.current.push(marker);
      });
      
      // Zoom naar alle markers
      if (groupLocations.length > 0) {
        const allPoints = [[gpsLat, gpsLng], ...groupLocations.map(l => [l.lat, l.lng])];
        const bounds = window.L.latLngBounds(allPoints);
        map.fitBounds(bounds, {padding: [30, 30]});
      }
    }, 100);
    
    // Cleanup is niet nodig - we behouden de kaart instance
  }, [leafletLoaded, screen, gpsLat, gpsLng, groupLocations, gpsAddress]);

  // ── PWA INSTALL ──
  const [installPrompt, setInstallPrompt] = useState(null);
  const [isInstalled, setIsInstalled]     = useState(false);
  const [isIOS, setIsIOS]                 = useState(false);
  const [showIOSGuide, setShowIOSGuide]   = useState(false);

  useEffect(() => {
    // Detecteer iOS
    const ios = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
    setIsIOS(ios);
    // Detecteer al geïnstalleerd
    if (window.matchMedia("(display-mode: standalone)").matches) setIsInstalled(true);
    // Service worker registreren
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js")
        .then(() => console.log("✅ Service worker actief"))
        .catch(err => console.log("SW fout:", err));
    }
    // Install prompt opvangen (Android/Chrome)
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    });
    window.addEventListener("appinstalled", () => setIsInstalled(true));
  }, []);

  const installApp = async () => {
    if (isIOS) { setShowIOSGuide(true); return; }
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === "accepted") setIsInstalled(true);
    setInstallPrompt(null);
  };

  const audioCtxRef = useRef(null);
  const alarmRef    = useRef(null);
  const timerRef    = useRef(null);
  const fakeCallRef = useRef(null);

  useEffect(() => {
    const upd = () => setTime(new Date().toLocaleTimeString("nl-NL",{hour:"2-digit",minute:"2-digit"}));
    upd(); const t = setInterval(upd,1000); return ()=>clearInterval(t);
  },[]);

  // GPS — echte locatie ophalen
  useEffect(() => {
    if (!navigator.geolocation) { setGpsStatus("denied"); setGpsAddress("GPS niet beschikbaar"); return; }
    const success = async (pos) => {
      const { latitude, longitude } = pos.coords;
      setGpsLat(latitude); setGpsLng(longitude); setGpsStatus("active");
      // Reverse geocode via OpenStreetMap (gratis, geen API key nodig)
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&accept-language=nl`);
        const data = await res.json();
        const addr = data.address;
        const road    = addr.road || addr.pedestrian || addr.footway || "";
        const number  = addr.house_number || "";
        const city    = addr.city || addr.town || addr.village || addr.municipality || "";
        setGpsAddress(`${road}${number ? " "+number : ""}, ${city}`.trim().replace(/^,|,$/g,"").trim());
      } catch { setGpsAddress(`${latitude.toFixed(4)}, ${longitude.toFixed(4)}`); }
    };
    const error = () => { setGpsStatus("denied"); setGpsAddress("Locatie geweigerd"); };
    navigator.geolocation.getCurrentPosition(success, error, { enableHighAccuracy:true });
    gpsWatchRef.current = navigator.geolocation.watchPosition(success, error, { enableHighAccuracy:true, maximumAge:10000 });
    return () => { if (gpsWatchRef.current != null) navigator.geolocation.clearWatch(gpsWatchRef.current); };
  },[]);

  // 3km melding simulatie — na 12s komt er een melding in de buurt
  useEffect(() => {
    const t = setTimeout(()=>setNearbyAlert(true), 12000);
    return ()=>clearTimeout(t);
  },[]);

  const playAlarm = () => {
    if (!audioCtxRef.current) audioCtxRef.current = new (window.AudioContext||window.webkitAudioContext)();
    const ctx = audioCtxRef.current;
    [880,1100,880,1100].forEach((freq,i)=>{
      const osc=ctx.createOscillator(), gain=ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination); osc.type="square";
      osc.frequency.setValueAtTime(freq,ctx.currentTime+i*0.15);
      gain.gain.setValueAtTime(0.3,ctx.currentTime+i*0.15);
      gain.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+i*0.15+0.14);
      osc.start(ctx.currentTime+i*0.15); osc.stop(ctx.currentTime+i*0.15+0.14);
    });
  };

  // Notificatie geluid (vriendelijk)
  const playNotification = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.setValueAtTime(880, ctx.currentTime);
    osc.frequency.setValueAtTime(1100, ctx.currentTime + 0.1);
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.3);
  };

  // Urgent notificatie geluid (voor alerts)
  const playUrgentNotification = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.2, 0.4].forEach((t) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.setValueAtTime(800, ctx.currentTime + t);
      gain.gain.setValueAtTime(0.4, ctx.currentTime + t);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + t + 0.15);
      osc.start(ctx.currentTime + t);
      osc.stop(ctx.currentTime + t + 0.15);
    });
  };

  const startAlarm = () => { 
    playAlarm(); 
    alarmRef.current=setInterval(playAlarm,700); 
    if(socketRef.current) socketRef.current.emit("alert", {lat:gpsLat, lng:gpsLng, address:gpsAddress}); 
  };
  const stopAlarm  = () => { clearInterval(alarmRef.current); };
  const goHome     = () => { 
    stopAlarm(); 
    setScreen("home"); 
    setActiveTab("home"); 
    if(socketRef.current) socketRef.current.emit("alert_dismiss"); 
  };

  const goSafeHome = () => {
    stopAlarm();
    stopTimer();
    const time = new Date().toLocaleTimeString("nl-NL",{hour:"2-digit",minute:"2-digit"});
    setSafeHomeTime(time);
    setScreen("safeHome");
    if(socketRef.current) socketRef.current.emit("safe_home", {time: time, address: gpsAddress});
  };

  const handlePay = () => {
    setPaying(true);
    setTimeout(()=>{ setPaying(false); setScreen("paySuccess"); },2400);
  };

  // Tijdklok
  const startTimer = (mins) => {
    setTimerMins(mins);
    setTimerLeft(mins*60);
    setTimerActive(true);
    timerRef.current = setInterval(()=>{
      setTimerLeft(prev=>{
        if (prev<=1) { clearInterval(timerRef.current); setTimerActive(false); setTimerLeft(0); setScreen("timerExpired"); return 0; }
        return prev-1;
      });
    },1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    setTimerActive(false);
    setTimerLeft(null);
  };

  const timerDisplay = (secs) => {
    if (!secs) return "--:--";
    const m = Math.floor(secs/60), s = secs%60;
    return `${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
  };

  // Nep-telefoontje
  const startFakeCall = (person) => {
    setFakeCallPerson(person);
    setFakeCallState("ringing");
    setFakeCallElapsed(0);
    setFakeCallActive(true);
    setTimeout(()=>{
      setFakeCallState("active");
      fakeCallRef.current = setInterval(()=>setFakeCallElapsed(p=>p+1), 1000);
    }, 3000);
  };

  const endFakeCall = () => {
    clearInterval(fakeCallRef.current);
    setFakeCallActive(false);
    setFakeCallElapsed(0);
  };

  const updateFriend = (i,v) => { const a=[...friendSlots]; a[i]={...a[i],email:v}; setFriendSlots(a); };
  const updateFriendGeslacht = (i,g) => { const a=[...friendSlots]; a[i]={...a[i],geslacht:g}; setFriendSlots(a); };

  const inp = { width:"100%", background:"#151e2e", border:"1px solid #2d3748", borderRadius:12, padding:"13px 14px", color:"#f9fafb", fontSize:14, outline:"none", fontFamily:"inherit", boxSizing:"border-box" };

  const goTo = (s) => { setPrevScreen(screen); setScreen(s); };

  const StatusBar = () => (
    <div style={{display:"flex",justifyContent:"space-between",padding:"14px 24px 8px",fontSize:13,color:"#6b7280",fontWeight:600,flexShrink:0}}>
      <span>{time}</span>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        {timerActive && <span style={{fontSize:11,color:"#fbbf24",fontWeight:700}}>⏱ {timerDisplay(timerLeft)}</span>}
        <span>📶 🔋</span>
      </div>
    </div>
  );

  const Progress = ({step}) => (
    <div style={{display:"flex",gap:6,marginBottom:4}}>
      {[1,2,3].map(i=>(
        <div key={i} style={{flex:1,height:3,borderRadius:4,background:i<=step?"linear-gradient(90deg,#6366f1,#8b5cf6)":"#1f2937",transition:"background .4s"}}/>
      ))}
    </div>
  );

  const BigBtn = ({label,onClick,grey,green,red}) => (
    <button onClick={onClick} style={{
      width:"100%",border:"none",borderRadius:16,padding:"16px",cursor:"pointer",fontSize:15,fontWeight:900,
      color:grey?"#9ca3af":"white",
      background:grey?"#1f2937":green?"linear-gradient(135deg,#14532d,#166534)":red?"linear-gradient(135deg,#dc2626,#b91c1c)":T.gradient,
      boxShadow:grey?"none":green?"0 4px 16px rgba(34,197,94,.25)":red?"0 4px 16px rgba(220,38,38,.3)":"0 6px 20px rgba(99,102,241,.35)",
      display:"flex",alignItems:"center",justifyContent:"center",gap:8,
    }}>{label}</button>
  );

  // Bottom nav
  const BottomNav = () => (
    <div style={{display:"flex",borderTop:"1px solid #1f2937",background:"#0d1117",flexShrink:0}}>
      {[
        {id:"home",  ico:"🛡️", label:"Home"},
        {id:"map",   ico:"🗺️", label:"Kaart"},
        {id:"timer", ico:"⏱",  label:"Timer"},
        {id:"fake",  ico:"📞", label:"Bel"},
        {id:"profile",ico:"👤",label:"Profiel"},
      ].map(tab=>(
        <button key={tab.id} onClick={()=>{setActiveTab(tab.id);setScreen(tab.id==="map"?"map":tab.id==="timer"?"timer":tab.id==="fake"?"fakeCall":tab.id==="profile"?"profile":"home");}} style={{flex:1,background:"transparent",border:"none",padding:"10px 4px 8px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
          <span style={{fontSize:18}}>{tab.ico}</span>
          <span style={{fontSize:9,fontWeight:700,color:activeTab===tab.id?"#6366f1":"#4b5563",textTransform:"uppercase",letterSpacing:.5}}>{tab.label}</span>
          {activeTab===tab.id && <div style={{width:20,height:2,borderRadius:2,background:"#6366f1"}}/>}
        </button>
      ))}
    </div>
  );

  const showNav = ["home","map","timer","fakeCall","profile","shared","police"].includes(screen);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;700;800;900&display=swap');
        *{box-sizing:border-box}
        @keyframes ping{75%,100%{transform:scale(2);opacity:0}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        @keyframes sosPulse{0%,100%{box-shadow:0 0 40px rgba(220,38,38,.5)}50%{box-shadow:0 0 70px rgba(220,38,38,.9)}}
        @keyframes spin{to{transform:rotate(360deg)}}
        @keyframes pop{0%{transform:scale(.7);opacity:0}80%{transform:scale(1.08)}100%{transform:scale(1);opacity:1}}
        @keyframes ring{0%,100%{transform:rotate(-15deg)}50%{transform:rotate(15deg)}}
        @keyframes slideUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
        @keyframes flash{0%,100%{opacity:1}50%{opacity:.4}}
        button:active{transform:scale(.97)}
        input::placeholder{color:#4b5563}
        input:focus{border-color:#6366f1!important;outline:none}
        ::-webkit-scrollbar{width:0}
      `}</style>

      <div style={{fontFamily:"'Outfit',sans-serif",background:"#080c14",minHeight:"100vh",display:"flex",justifyContent:"center",alignItems:"center",padding:20}}>
        <div style={{width:360,minHeight:740,maxHeight:820,background:"#111827",borderRadius:44,border:"2px solid #1f2937",boxShadow:"0 40px 80px rgba(0,0,0,.65),inset 0 1px 0 rgba(255,255,255,.05)",overflow:"hidden",display:"flex",flexDirection:"column",position:"relative"}}>

          {/* NEPPEL OVERLAY */}
          {fakeCallActive && (
            <div style={{position:"absolute",inset:0,background:"#0a0f1a",zIndex:100,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",padding:"60px 30px 50px",animation:"slideUp .3s ease"}}>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:10,color:"#4b5563",fontWeight:700,textTransform:"uppercase",letterSpacing:1.5,marginBottom:20}}>
                  {fakeCallState==="ringing"?"Inkomend gesprek":"Gesprek actief"}
                </div>
                <div style={{fontSize:80,marginBottom:16,animation:fakeCallState==="ringing"?"ring 0.5s ease infinite":""}}>{fakeCallPerson.emoji}</div>
                <div style={{fontSize:26,fontWeight:900,color:"#f9fafb"}}>{fakeCallPerson.name}</div>
                <div style={{fontSize:13,color:"#6b7280",marginTop:6}}>
                  {fakeCallState==="ringing"
                    ? <span style={{animation:"flash 1s ease infinite",display:"inline-block"}}>Belt...</span>
                    : timerDisplay(fakeCallElapsed)}
                </div>
              </div>
              <div style={{display:"flex",gap:24,justifyContent:"center"}}>
                {fakeCallState==="ringing" && (
                  <button onClick={()=>{setFakeCallState("active"); fakeCallRef.current=setInterval(()=>setFakeCallElapsed(p=>p+1),1000);}} style={{width:64,height:64,borderRadius:"50%",background:"#16a34a",border:"none",fontSize:24,cursor:"pointer",boxShadow:"0 0 20px rgba(22,163,74,.4)"}}>📞</button>
                )}
                <button onClick={endFakeCall} style={{width:64,height:64,borderRadius:"50%",background:"#dc2626",border:"none",fontSize:24,cursor:"pointer",boxShadow:"0 0 20px rgba(220,38,38,.4)"}}>📵</button>
              </div>
            </div>
          )}

          {/* 3KM ALERT NOTIFICATIE */}
          {nearbyAlert && screen==="home" && (
            <div onClick={()=>setNearbyAlert(false)} style={{position:"absolute",top:60,left:16,right:16,background:"linear-gradient(135deg,#7f1d1d,#991b1b)",border:"1px solid rgba(239,68,68,.4)",borderRadius:14,padding:"11px 14px",zIndex:50,animation:"slideUp .4s ease",cursor:"pointer",boxShadow:"0 8px 24px rgba(220,38,38,.3)"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <span style={{fontSize:20,animation:"ping 1s ease infinite",display:"inline-block"}}>🚨</span>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:800,color:"white"}}>Melding binnen 3 km!</div>
                  <div style={{fontSize:11,color:"#fca5a5",marginTop:2}}>Melding in jouw buurt</div>
                </div>
                <span style={{fontSize:11,color:"#6b7280"}}>✕</span>
              </div>
            </div>
          )}

          {friendAlert && screen==="home" && (
            <div onClick={()=>{setFriendAlert(null);if(friendAlarmRef.current){clearInterval(friendAlarmRef.current);friendAlarmRef.current=null;}}} style={{position:"absolute",top:nearbyAlert?130:60,left:16,right:16,background:"linear-gradient(135deg,#991b1b,#dc2626)",border:"2px solid #f87171",borderRadius:14,padding:"14px",zIndex:51,animation:"slideUp .4s ease",cursor:"pointer",boxShadow:"0 8px 32px rgba(220,38,38,.5)"}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,animation:"sosPulse 1s ease infinite"}}>🚨</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:900,color:"white"}}>{friendAlert.naam} heeft hulp nodig!</div>
                  <div style={{fontSize:11,color:"#fca5a5",marginTop:3}}>{friendAlert.address || "Locatie onbekend"}</div>
                </div>
                <span style={{fontSize:13,color:"rgba(255,255,255,.5)"}}>✕</span>
              </div>
            </div>
          )}

          {friendLocation && screen==="home" && (
            <div onClick={()=>setFriendLocation(null)} style={{position:"absolute",top:friendAlert?200:(nearbyAlert?130:60),left:16,right:16,background:"linear-gradient(135deg,#14532d,#166534)",border:"2px solid #22c55e",borderRadius:14,padding:"14px",zIndex:50,animation:"slideUp .4s ease",cursor:"pointer",boxShadow:"0 8px 24px rgba(34,197,94,.3)"}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>📍</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:900,color:"white"}}>{friendLocation.naam} deelt locatie</div>
                  <div style={{fontSize:11,color:"#86efac",marginTop:3}}>{friendLocation.address || "Locatie onbekend"}</div>
                </div>
                <span style={{fontSize:13,color:"rgba(255,255,255,.5)"}}>✕</span>
              </div>
            </div>
          )}

          {friendSafe && screen==="home" && (
            <div onClick={()=>setFriendSafe(null)} style={{position:"absolute",top:friendAlert?200:(friendLocation?200:(nearbyAlert?130:60)),left:16,right:16,background:"linear-gradient(135deg,#052e16,#14532d)",border:"2px solid #4ade80",borderRadius:14,padding:"14px",zIndex:49,animation:"slideUp .4s ease",cursor:"pointer",boxShadow:"0 8px 24px rgba(74,222,128,.3)"}}>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.15)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>🏠</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:900,color:"#4ade80"}}>{friendSafe.naam} is veilig thuis!</div>
                  <div style={{fontSize:11,color:"#86efac",marginTop:3}}>Aangekomen om {friendSafe.time}</div>
                </div>
                <span style={{fontSize:13,color:"rgba(255,255,255,.5)"}}>✕</span>
              </div>
            </div>
          )}

          <StatusBar/>

          {/* ══ ONBOARDING ══ */}
          {/* ══ LOGIN SCHERM ══ */}
          {screen==="login" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"24px 22px",gap:14,animation:"fadeUp .4s ease",justifyContent:"center"}}>
              <div style={{textAlign:"center",marginBottom:8}}>
                <div style={{fontSize:36,marginBottom:8}}>🛡️</div>
                <div style={{fontSize:22,fontWeight:900,color:"#f9fafb"}}>Inloggen</div>
                <div style={{fontSize:13,color:"#6b7280",marginTop:4}}>Welkom terug</div>
              </div>

              <div>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>E-mail</div>
                <input style={inp} placeholder="jij@email.nl" type="email"
                  value={signupData.email} onChange={e=>setSignupData(p=>({...p,email:e.target.value}))}/>
              </div>

              <div>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Wachtwoord</div>
                <input style={inp} placeholder="••••••••" type="password"
                  value={signupData.wachtwoord} onChange={e=>setSignupData(p=>({...p,wachtwoord:e.target.value}))}/>
              </div>

              {apiError && <div style={{background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",borderRadius:10,padding:"10px 12px",fontSize:12,color:"#f87171"}}>⚠ {apiError}</div>}

              <button onClick={async ()=>{
                setApiError("");
                if(!signupData.email || !signupData.wachtwoord) { setApiError("Vul je e-mail en wachtwoord in"); return; }
                setApiLoading(true);
                try {
                  const d = await api("/api/login", {
                    method:"POST",
                    body: JSON.stringify({ email:signupData.email, wachtwoord:signupData.wachtwoord })
                  });
                  login(d.token, d.user);
                  setScreen("home");
                } catch(err) { setApiError(err.message); }
                finally { setApiLoading(false); }
              }}
                style={{width:"100%",background:"linear-gradient(135deg,#9d174d,#ec4899)",border:"none",borderRadius:14,padding:"14px",color:"white",fontSize:15,fontWeight:900,cursor:"pointer",opacity:apiLoading?0.7:1}}>
                {apiLoading ? "Inloggen..." : "Inloggen →"}
              </button>

              <button onClick={()=>{ setApiError(""); setScreen("onboarding"); }}
                style={{background:"transparent",border:"none",color:"#4b5563",fontSize:13,cursor:"pointer",padding:6}}>
                ← Terug naar aanmelden
              </button>
            </div>
          )}

          {/* ── iOS INSTALL GUIDE ── */}}
          {showIOSGuide && (
            <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:200,display:"flex",alignItems:"flex-end",padding:"0 0 20px"}}>
              <div style={{background:"#1a0d18",border:"1px solid #3d1a35",borderRadius:"20px 20px 14px 14px",padding:"20px",width:"100%",animation:"fadeUp .3s ease"}}>
                <div style={{textAlign:"center",marginBottom:14}}>
                  <div style={{fontSize:28,marginBottom:6}}>📱</div>
                  <div style={{fontSize:16,fontWeight:900,color:"#f9fafb"}}>Installeer op iPhone</div>
                </div>
                {[
                  ["1", "Tik op het Deel icoon", "⬆️"],
                  ["2", "Scroll naar beneden", "👇"],
                  ["3", "Tik op 'Zet op beginscherm'", "➕"],
                  ["4", "Tik op 'Voeg toe'", "✅"],
                ].map(([n,t,e])=>(
                  <div key={n} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10,background:"rgba(255,255,255,.04)",borderRadius:10,padding:"10px 12px"}}>
                    <div style={{width:24,height:24,borderRadius:"50%",background:"linear-gradient(135deg,#9d174d,#ec4899)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:900,color:"white",flexShrink:0}}>{n}</div>
                    <div style={{fontSize:13,color:"#e5e7eb",flex:1}}>{t}</div>
                    <div style={{fontSize:18}}>{e}</div>
                  </div>
                ))}
                <button onClick={()=>setShowIOSGuide(false)}
                  style={{width:"100%",marginTop:8,background:"linear-gradient(135deg,#9d174d,#ec4899)",border:"none",borderRadius:12,padding:"13px",color:"white",fontSize:14,fontWeight:800,cursor:"pointer"}}>
                  Begrepen ✓
                </button>
              </div>
            </div>
          )}

{screen==="onboarding" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",padding:"4px 28px 32px",animation:"fadeUp .4s ease"}}>
              <div/>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:56,marginBottom:10}}>🛡️</div>
                <div style={{fontSize:26,fontWeight:900,color:"#f9fafb",letterSpacing:"-1px",lineHeight:1.2}}>Get Home Safe</div>
                <div style={{fontSize:13,color:"#6b7280",marginTop:8,lineHeight:1.8}}>Nooit meer alleen onderweg</div>
                <div style={{marginTop:20,display:"flex",flexDirection:"column",gap:7}}>
                  {[["📍","Live locatie met vriendinnen"],["🚨","Noodalarm met geluid"],["📡","3km community melding"],["⏱","Tijdklok — ben je er veilig?"],["📞","Nep-telefoontje"],["🏠","Veilig thuis melden"]].map(([ico,txt])=>(
                    <div key={txt} style={{display:"flex",alignItems:"center",gap:10,background:"rgba(255,255,255,.03)",border:"1px solid #1f2937",borderRadius:11,padding:"9px 13px"}}>
                      <span style={{fontSize:17}}>{ico}</span>
                      <span style={{fontSize:13,color:"#d1d5db",fontWeight:600}}>{txt}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div style={{width:"100%",display:"flex",flexDirection:"column",gap:9,marginTop:20}}>
                <BigBtn label="Nieuw account →" onClick={()=>setScreen("pricing")}/>
                <button onClick={()=>setScreen("joinCode")} style={{width:"100%",background:"rgba(34,197,94,.1)",border:"1px solid rgba(34,197,94,.3)",borderRadius:14,padding:"14px",color:"#4ade80",fontSize:14,fontWeight:700,cursor:"pointer"}}>🎁 Ik heb een groepscode</button>
                <button onClick={()=>setScreen("login")} style={{background:"transparent",border:"none",color:"#6b7280",fontSize:13,cursor:"pointer",padding:6}}>Al een account? Inloggen →</button>
              </div>
            </div>
          )}

{/* ══ JOIN MET CODE ══ */}
          {screen==="joinCode" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"6px 22px 26px",gap:14,animation:"fadeUp .4s ease"}}>
              <button onClick={()=>setScreen("onboarding")} style={{background:"transparent",border:"none",color:"#6b7280",fontSize:13,cursor:"pointer",padding:4,alignSelf:"flex-start"}}>← Terug</button>
              <div style={{textAlign:"center"}}>
                <div style={{fontSize:40,marginBottom:8}}>🎁</div>
                <div style={{fontSize:22,fontWeight:900,color:"#f9fafb"}}>Heb je een code?</div>
                <div style={{fontSize:13,color:"#6b7280",marginTop:4}}>Vul de groepscode van je vriend(in) in</div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <input
                  style={{...inp,flex:1,textAlign:"center",letterSpacing:2,fontSize:16,fontWeight:700,textTransform:"uppercase"}}
                  placeholder="GHS-XXXX-XXXX"
                  value={invoerCode}
                  maxLength={13}
                  onChange={e=>{
                    setInvoerCode(e.target.value.toUpperCase());
                    setCodeStatus("idle");
                    setCodeCheck(null);
                  }}
                />
              </div>
              {codeStatus==="valid" && codeCheck && (
                <div style={{background:"rgba(34,197,94,.1)",border:"1px solid rgba(34,197,94,.3)",borderRadius:12,padding:"12px 14px"}}>
                  <div style={{fontSize:14,color:"#4ade80",fontWeight:700}}>✅ Geldige code!</div>
                  <div style={{fontSize:13,color:"#6b7280",marginTop:4}}>Groep van <strong style={{color:"#f9fafb"}}>{codeCheck.eigenaar_naam}</strong> — {codeCheck.vrije_plekken} plek{codeCheck.vrije_plekken!==1?"ken":""} vrij</div>
                </div>
              )}
              {codeStatus==="invalid" && (
                <div style={{background:"rgba(239,68,68,.1)",border:"1px solid rgba(239,68,68,.3)",borderRadius:12,padding:"12px 14px",fontSize:13,color:"#f87171"}}>
                  ❌ {codeCheck?.error || "Ongeldige of verlopen code"}
                </div>
              )}
              {codeStatus!=="valid" && (
                <BigBtn 
                  label={codeStatus==="checking" ? "Controleren..." : "Controleer code"} 
                  onClick={async ()=>{
                    if(invoerCode.length < 13) return;
                    setCodeStatus("checking");
                    try {
                      const r = await fetch(`/api/groep/check/${invoerCode}`);
                      const d = await r.json();
                      if(r.ok) { setCodeCheck(d); setCodeStatus("valid"); }
                      else { setCodeStatus("invalid"); setCodeCheck({error: d.error}); }
                    } catch { setCodeStatus("invalid"); }
                  }}
                  grey={invoerCode.length < 13}
                />
              )}
              {codeStatus==="valid" && (
                <BigBtn 
                  label="🎉 Gratis account maken →" 
                  onClick={()=>{
                    setJoinWithCode(true);
                    setScreen("signup");
                    setSignupStep(0);
                  }}
                />
              )}
            </div>
          )}
          {/* ══ PRICING ══ */}
          {screen==="pricing" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"6px 20px 24px",gap:10,animation:"fadeUp .4s ease",overflowY:"auto"}}>
              <div style={{textAlign:"center",marginBottom:2}}>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,textTransform:"uppercase",letterSpacing:1.5}}>Abonnement</div>
                <div style={{fontSize:21,fontWeight:900,color:"#f9fafb",marginTop:4}}>Kies jouw plan</div>
              </div>
              <div style={{background:"#151e2e",border:"1px solid #374151",borderRadius:18,padding:"16px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:10}}>
                  <div><div style={{fontSize:15,fontWeight:800,color:"#f9fafb"}}>Solo</div><div style={{fontSize:12,color:"#6b7280"}}>Alleen voor jezelf</div></div>
                  <div style={{textAlign:"right"}}><div style={{fontSize:22,fontWeight:900,color:"#f9fafb"}}>€2,99</div><div style={{fontSize:11,color:"#6b7280"}}>/maand</div></div>
                </div>
                {["Locatiedeling","Noodalarm","Tijdklok","Nep-telefoontje","3km community melding","Politie bellen"].map(f=>(
                  <div key={f} style={{display:"flex",gap:8,alignItems:"center",marginBottom:4}}>
                    <span style={{color:"#4ade80",fontSize:12}}>✓</span><span style={{fontSize:12,color:"#9ca3af"}}>{f}</span>
                  </div>
                ))}
                <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:4,opacity:.4}}>
                  <span style={{color:"#6b7280",fontSize:12}}>✗</span><span style={{fontSize:12,color:"#4b5563"}}>Vriendinnen uitnodigen</span>
                </div>
                <div style={{marginTop:10}}><BigBtn label="Kies Solo" onClick={()=>{setScreen("signup");setSignupStep(0);}} grey/></div>
              </div>

              <div style={{background:"linear-gradient(135deg,rgba(99,102,241,.12),rgba(139,92,246,.07))",border:"2px solid #6366f1",borderRadius:18,padding:"16px",position:"relative",marginTop:6}}>
                <div style={{position:"absolute",top:-13,left:"50%",transform:"translateX(-50%)",background:T.gradient,borderRadius:20,padding:"4px 16px",fontSize:11,fontWeight:800,color:"white",whiteSpace:"nowrap"}}>⭐ MEEST GEKOZEN</div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginTop:4,marginBottom:8}}>
                  <div><div style={{fontSize:15,fontWeight:800,color:"#f9fafb"}}>Groep</div><div style={{fontSize:12,color:"#a5b4fc"}}>Jij + 5 vriendinnen</div></div>
                  <div style={{textAlign:"right"}}><div style={{fontSize:22,fontWeight:900,color:"#f9fafb"}}>€4,99</div><div style={{fontSize:11,color:"#6b7280"}}>/maand</div></div>
                </div>
                <div style={{background:"rgba(99,102,241,.15)",border:"1px solid rgba(99,102,241,.3)",borderRadius:12,padding:"8px 12px",marginBottom:8}}>
                  <div style={{fontSize:12,fontWeight:800,color:"#a5b4fc",marginBottom:4}}>🎉 Vriendinnen liften gratis mee!</div>
                  <div style={{display:"flex",marginBottom:4}}>
                    {["J","S","L","M","A","N"].map((l,i)=>(
                      <div key={i} style={{width:22,height:22,borderRadius:"50%",background:i===0?T.gradient:"#374151",border:"2px solid #111827",display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:800,color:"white",marginLeft:i>0?-6:0}}>{l}</div>
                    ))}
                  </div>
                </div>
                {["Alles van Solo","5 vriendinnen uitnodigen","Groepsllocatie overzicht"].map(f=>(
                  <div key={f} style={{display:"flex",gap:8,alignItems:"center",marginBottom:4}}>
                    <span style={{color:"#4ade80",fontSize:12}}>✓</span><span style={{fontSize:12,color:"#d1d5db"}}>{f}</span>
                  </div>
                ))}
                <div style={{marginTop:10}}><BigBtn label="Kies Groep →" onClick={()=>{setScreen("signup");setSignupStep(0);}}/></div>
              </div>
              <div style={{textAlign:"center",fontSize:11,color:"#374151"}}>Geen verborgen kosten · Maandelijks opzegbaar</div>
            </div>
          )}

          {/* ══ GESLACHT KEUZE ══ */}
          {screen==="signup" && signupStep===0 && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"6px 22px 26px",gap:16,animation:"fadeUp .4s ease",alignItems:"center",justifyContent:"center"}}>
              <div style={{textAlign:"center",marginBottom:8}}>
                <div style={{fontSize:22,fontWeight:900,color:"#f9fafb"}}>Wie ben jij?</div>
                <div style={{fontSize:13,color:"#6b7280",marginTop:4}}>Kies jouw stijl — je kan dit later aanpassen</div>
              </div>
              <div style={{display:"flex",gap:14,width:"100%"}}>
                {/* VROUW */}
                <div onClick={()=>setGeslacht("vrouw")}
                  style={{flex:1,borderRadius:20,padding:"24px 12px",textAlign:"center",cursor:"pointer",transition:"all .3s",
                    background:geslacht==="vrouw"?"linear-gradient(135deg,#9d174d,#ec4899)":"#1a0d18",
                    border:`2px solid ${geslacht==="vrouw"?"#ec4899":"#3d1a35"}`,
                    boxShadow:geslacht==="vrouw"?"0 8px 30px rgba(236,72,153,.35)":"none"}}>
                  <div style={{fontSize:48,marginBottom:10}}>👩</div>
                  <div style={{fontSize:16,fontWeight:900,color:"white",marginBottom:4}}>Vrouw</div>
                  <div style={{fontSize:11,color:geslacht==="vrouw"?"rgba(255,255,255,.7)":"#6b7280"}}>Roze · Wit · Stijlvol</div>
                  <div style={{display:"flex",gap:5,justifyContent:"center",marginTop:10}}>
                    {["#ec4899","#f9a8d4","#ffffff"].map(c=>(
                      <div key={c} style={{width:14,height:14,borderRadius:"50%",background:c,border:"1px solid rgba(255,255,255,.2)"}}/>
                    ))}
                  </div>
                </div>
                {/* MAN */}
                <div onClick={()=>setGeslacht("man")}
                  style={{flex:1,borderRadius:20,padding:"24px 12px",textAlign:"center",cursor:"pointer",transition:"all .3s",
                    background:geslacht==="man"?"linear-gradient(135deg,#1e3a8a,#2563eb)":"#060d1a",
                    border:`2px solid ${geslacht==="man"?"#3b82f6":"#1e3a5f"}`,
                    boxShadow:geslacht==="man"?"0 8px 30px rgba(37,99,235,.35)":"none"}}>
                  <div style={{fontSize:48,marginBottom:10}}>👨</div>
                  <div style={{fontSize:16,fontWeight:900,color:"white",marginBottom:4}}>Man</div>
                  <div style={{fontSize:11,color:geslacht==="man"?"rgba(255,255,255,.7)":"#6b7280"}}>Donkerblauw · Zwart</div>
                  <div style={{display:"flex",gap:5,justifyContent:"center",marginTop:10}}>
                    {["#1e40af","#2563eb","#1e293b"].map(c=>(
                      <div key={c} style={{width:14,height:14,borderRadius:"50%",background:c,border:"1px solid rgba(255,255,255,.2)"}}/>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{width:"100%",marginTop:8}}>
                <button onClick={()=>setSignupStep(1)}
                  style={{width:"100%",background:geslacht==="man"?"linear-gradient(135deg,#1e3a8a,#2563eb)":"linear-gradient(135deg,#9d174d,#ec4899)",
                    border:"none",borderRadius:14,padding:"15px",color:"white",fontSize:15,fontWeight:900,cursor:"pointer",
                    boxShadow:geslacht==="man"?"0 4px 20px rgba(37,99,235,.4)":"0 4px 20px rgba(236,72,153,.4)"}}>
                  Doorgaan →
                </button>
              </div>
            </div>
          )}

          {/* ══ SIGNUP stap 1 ══ */}
          {screen==="signup" && signupStep===1 && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"6px 22px 26px",gap:12,animation:"fadeUp .4s ease"}}>
              <Progress step={1}/>
              <div><div style={{fontSize:19,fontWeight:900,color:"#f9fafb"}}>Jouw gegevens</div><div style={{fontSize:12,color:"#6b7280",marginTop:3}}>Stap 1 van 3</div></div>

              <div>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Naam *</div>
                <input style={{...inp,borderColor:signupErrors.naam?"#ef4444":undefined}} placeholder="Voornaam" type="text"
                  value={signupData.naam} onChange={e=>setSignupData(p=>({...p,naam:e.target.value}))}/>
                {signupErrors.naam && <div style={{fontSize:11,color:"#f87171",marginTop:3}}>⚠ {signupErrors.naam}</div>}
              </div>

              <div>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>E-mail *</div>
                <input style={{...inp,borderColor:signupErrors.email?"#ef4444":undefined}} placeholder="jij@email.nl" type="email"
                  value={signupData.email} onChange={e=>setSignupData(p=>({...p,email:e.target.value}))}/>
                {signupErrors.email && <div style={{fontSize:11,color:"#f87171",marginTop:3}}>⚠ {signupErrors.email}</div>}
              </div>

              <div>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Telefoon</div>
                <input style={inp} placeholder="+31 6 …" type="tel"
                  value={signupData.telefoon} onChange={e=>setSignupData(p=>({...p,telefoon:e.target.value}))}/>
              </div>

              <div>
                <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>Wachtwoord * <span style={{color:"#4b5563",fontWeight:400,textTransform:"none"}}>(min. 8 tekens)</span></div>
                <input style={{...inp,borderColor:signupErrors.wachtwoord?"#ef4444":undefined}} placeholder="••••••••" type="password"
                  value={signupData.wachtwoord} onChange={e=>setSignupData(p=>({...p,wachtwoord:e.target.value}))}/>
                {signupErrors.wachtwoord && <div style={{fontSize:11,color:"#f87171",marginTop:3}}>⚠ {signupErrors.wachtwoord}</div>}
              </div>


<div style={{marginTop:"auto"}}>
                <BigBtn label={joinWithCode ? "🎉 Gratis account maken →" : "Volgende →"} onClick={async ()=>{
                  const errors = {};
                  if (!signupData.naam || signupData.naam.trim().length < 2) errors.naam = "Naam is verplicht";
                  if (!signupData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signupData.email)) errors.email = "Geldig e-mailadres verplicht";
                  if (!signupData.wachtwoord || signupData.wachtwoord.length < 8) errors.wachtwoord = "Minimaal 8 tekens";
                  setSignupErrors(errors);
                  if (Object.keys(errors).length === 0) {
                    if (joinWithCode) {
                      setApiLoading(true);
                      try {
                        const d = await api("/api/register", {
                          method:"POST",
                          body: JSON.stringify({
                            naam: signupData.naam,
                            email: signupData.email,
                            telefoon: signupData.telefoon,
                            wachtwoord: signupData.wachtwoord,
                            geslacht: geslacht,
                            groepscode: invoerCode,
                          })
                        });
                        login(d.token, d.user);
                        setJoinWithCode(false);
                        setScreen("home");
                      } catch(err) { setApiError(err.message); }
                      finally { setApiLoading(false); }
                    } else {
                      setSignupStep(2);
                    }
                  }
                }}/>
                {apiError && <div style={{textAlign:"center",fontSize:12,color:"#f87171",marginTop:4}}>⚠ {apiError}</div>}
                {apiLoading && <div style={{textAlign:"center",fontSize:12,color:"#a5b4fc",marginTop:4}}>Even geduld...</div>}
              </div>
            </div>
          )}

          {/* ══ SIGNUP stap 2 ══ */}
          {screen==="signup" && signupStep===2 && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"6px 22px 26px",gap:10,animation:"fadeUp .4s ease",overflowY:"auto"}}>
              <Progress step={2}/>
              <div><div style={{fontSize:19,fontWeight:900,color:"#f9fafb"}}>Nodig vriendinnen uit</div><div style={{fontSize:12,color:"#6b7280",marginTop:3}}>Stap 2 van 3</div></div>
              <div style={{background:"rgba(99,102,241,.1)",border:"1px solid rgba(99,102,241,.25)",borderRadius:12,padding:"10px 13px"}}>
                <div style={{fontSize:13,color:"#a5b4fc",lineHeight:1.6}}>🎉 <strong>Jij betaalt €4,99/mnd</strong> — vriendinnen krijgen gratis toegang.</div>
              </div>
              {friendSlots.map((slot,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:8}}>
                  <div style={{width:26,height:26,borderRadius:"50%",background:"#1f2937",border:"1px solid #374151",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#6b7280",fontWeight:700,flexShrink:0}}>{i+1}</div>
                  <input style={{...inp,flex:1}} placeholder={`E-mail vriend${slot.geslacht==="man"?"":"in"} ${i+1}`} value={slot.email} onChange={e=>updateFriend(i,e.target.value)}/>
                  {/* M/V toggle */}
                  <div style={{display:"flex",borderRadius:8,overflow:"hidden",border:"1px solid #374151",flexShrink:0}}>
                    <button onClick={()=>updateFriendGeslacht(i,"vrouw")}
                      style={{padding:"6px 10px",background:slot.geslacht==="vrouw"?"rgba(236,72,153,.3)":"transparent",border:"none",color:slot.geslacht==="vrouw"?"#f9a8d4":"#4b5563",fontSize:13,cursor:"pointer",fontWeight:700}}>
                      ♀
                    </button>
                    <button onClick={()=>updateFriendGeslacht(i,"man")}
                      style={{padding:"6px 10px",background:slot.geslacht==="man"?"rgba(37,99,235,.3)":"transparent",border:"none",color:slot.geslacht==="man"?"#93c5fd":"#4b5563",fontSize:13,cursor:"pointer",fontWeight:700}}>
                      ♂
                    </button>
                  </div>
                </div>
              ))}
              <div style={{marginTop:"auto",display:"flex",flexDirection:"column",gap:8}}>
                <BigBtn label="Volgende →" onClick={async ()=>{
                  setApiError("");
                  setApiLoading(true);
                  try {
                    const vrienden = friendSlots.filter(f=>f.email.trim());
                    const d = await api("/api/register", {
                      method:"POST",
                      body: JSON.stringify({
                        naam: signupData.naam,
                        email: signupData.email,
                        telefoon: signupData.telefoon,
                        wachtwoord: signupData.wachtwoord,
                        geslacht: geslacht,
                        groepscode: invoerCode || undefined,
                        vrienden,
                      })
                    });
                    login(d.token, d.user);
                    if(joinWithCode){setScreen("home");setJoinWithCode(false);}else{setScreen("payment");}
                  } catch(err) {
                    setApiError(err.message);
                  } finally { setApiLoading(false); }
                }}/>
                {apiError && <div style={{textAlign:"center",fontSize:12,color:"#f87171",marginTop:4}}>⚠ {apiError}</div>}
                {apiLoading && <div style={{textAlign:"center",fontSize:12,color:"#a5b4fc",marginTop:4}}>Even geduld...</div>}
                <button onClick={()=>setScreen("payment")} style={{background:"transparent",border:"none",color:"#4b5563",fontSize:13,cursor:"pointer",padding:4}}>Overslaan</button>
              </div>
            </div>
          )}

          {/* ══ PAYMENT ══ */}
          {screen==="payment" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"6px 22px 26px",gap:10,animation:"fadeUp .4s ease",overflowY:"auto"}}>
              <Progress step={3}/>
              <div><div style={{fontSize:19,fontWeight:900,color:"#f9fafb"}}>Betaling</div><div style={{fontSize:12,color:"#6b7280",marginTop:3}}>Stap 3 van 3</div></div>

              {/* ── GROEPSCODE OPTIE ── */}
              <div style={{background:"rgba(99,102,241,.08)",border:"1px solid rgba(99,102,241,.2)",borderRadius:14,padding:"13px 14px"}}>
                <div style={{fontSize:12,fontWeight:800,color:"#a5b4fc",marginBottom:8}}>🎁 Heb je een groepscode?</div>
                <div style={{fontSize:11,color:"#6b7280",marginBottom:10,lineHeight:1.6}}>Als een vriend/vriendin al betaalt, kan jij gratis meedoen met hun code.</div>
                <div style={{display:"flex",gap:7}}>
                  <input
                    style={{flex:1,background:"#0d1117",border:`1px solid ${codeStatus==="valid"?"#22c55e":codeStatus==="invalid"?"#ef4444":"#374151"}`,borderRadius:9,padding:"10px 12px",color:"#f9fafb",fontSize:13,fontFamily:"monospace",letterSpacing:2,outline:"none",textTransform:"uppercase"}}
                    placeholder="GHS-XXXX-XXXX"
                    value={invoerCode}
                    maxLength={13}
                    onChange={e => {
                      const v = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g,"");
                      // Auto format: GHS-XXXX-XXXX
                      let formatted = v.slice(0,3);
                      if(v.length>3) formatted += "-" + v.slice(3,7);
                      if(v.length>7) formatted += "-" + v.slice(7,11);
                      setInvoerCode(formatted);
                      setCodeStatus("idle");
                      setCodeCheck(null);
                    }}
                  />
                  <button
                    onClick={async () => {
                      if(invoerCode.length < 11) return;
                      setCodeStatus("checking");
                      try {
                        const r = await fetch(`/api/groep/check/${invoerCode}`);
                        const d = await r.json();
                        if(r.ok) { setCodeCheck(d); setCodeStatus("valid"); }
                        else { setCodeStatus("invalid"); setCodeCheck({error: d.error}); }
                      } catch { setCodeStatus("invalid"); }
                    }}
                    style={{background:"rgba(99,102,241,.2)",border:"1px solid rgba(99,102,241,.3)",borderRadius:9,padding:"10px 14px",color:"#a5b4fc",fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
                    {codeStatus==="checking" ? "⏳" : "Controleer"}
                  </button>
                </div>
                {codeStatus==="valid" && codeCheck && (
                  <div style={{marginTop:8,background:"rgba(34,197,94,.08)",border:"1px solid rgba(34,197,94,.2)",borderRadius:9,padding:"9px 12px",fontSize:12,color:"#4ade80"}}>
                    ✅ Geldige code! Groep van <strong>{codeCheck.eigenaar_naam}</strong> — {codeCheck.vrije_plekken} plek{codeCheck.vrije_plekken!==1?"ken":""} vrij
                  </div>
                )}
                {codeStatus==="invalid" && (
                  <div style={{marginTop:8,fontSize:11,color:"#f87171"}}>❌ {codeCheck?.error || "Ongeldige code"}</div>
                )}
              </div>

              {/* Als code geldig is — gratis aanmelden knop */}
              {codeStatus==="valid" && (
                <button onClick={()=>setScreen("paySuccess")}
                  style={{width:"100%",background:"linear-gradient(135deg,#059669,#10b981)",border:"none",borderRadius:14,padding:"15px",color:"white",fontSize:15,fontWeight:900,cursor:"pointer",boxShadow:"0 4px 20px rgba(16,185,129,.3)"}}>
                  🎉 Gratis aanmelden met groepscode →
                </button>
              )}

              {/* Scheidslijn */}
              {codeStatus!=="valid" && (
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{flex:1,height:1,background:"#1f2937"}}/>
                  <span style={{fontSize:11,color:"#374151",fontWeight:600}}>OF BETAAL ZELF</span>
                  <div style={{flex:1,height:1,background:"#1f2937"}}/>
                </div>
              )}
              <div style={{background:"#151e2e",border:"1px solid #2d3748",borderRadius:13,padding:"13px"}}>
                {[["🛡 Get Home Safe Groep","€4,99/mnd"],["👥 5 vriendinnen","Gratis"]].map(([l,v],i)=>(
                  <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{fontSize:13,color:"#d1d5db"}}>{l}</span>
                    <span style={{fontSize:13,color:v==="Gratis"?"#4ade80":"#f9fafb",fontWeight:700}}>{v}</span>
                  </div>
                ))}
                <div style={{borderTop:"1px solid #2d3748",marginTop:8,paddingTop:8,display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontSize:14,fontWeight:800,color:"#f9fafb"}}>Totaal</span>
                  <span style={{fontSize:15,fontWeight:900,color:"#f9fafb"}}>€4,99/mnd</span>
                </div>
              </div>
              {[["Kaartnummer","1234 5678 9012 3456"],["Vervaldatum","MM/JJ"]].map(([l,p])=>(
                <div key={l}>
                  <div style={{fontSize:11,color:"#6b7280",fontWeight:700,marginBottom:5,textTransform:"uppercase",letterSpacing:.8}}>{l}</div>
                  <input style={inp} placeholder={p}/>
                </div>
              ))}
              <div style={{display:"flex",gap:8}}>
                {["💳 iDEAL","🍎 Apple Pay","🅿️ PayPal"].map(m=>(
                  <div key={m} style={{flex:1,background:"#151e2e",border:"1px solid #374151",borderRadius:10,padding:"8px 4px",textAlign:"center",fontSize:11,color:"#6b7280",cursor:"pointer",fontWeight:600}}>{m}</div>
                ))}
              </div>
              <div style={{marginTop:"auto"}}>
                <button onClick={handlePay} style={{width:"100%",background:paying?"#374151":T.gradient,border:"none",borderRadius:15,padding:"16px",color:"white",fontSize:15,fontWeight:900,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:10,transition:"all .3s"}}>
                  {paying?<><span style={{width:17,height:17,border:"2px solid rgba(255,255,255,.3)",borderTopColor:"white",borderRadius:"50%",display:"inline-block",animation:"spin .8s linear infinite"}}/>Bezig…</>:"🔒 Betaal €4,99"}
                </button>
              </div>
            </div>
          )}

          {/* ══ PAY SUCCESS ══ */}
          {screen==="paySuccess" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px",gap:14,animation:"fadeUp .4s ease",textAlign:"center"}}>
              <div style={{fontSize:60,animation:"pop .5s ease"}}>🎉</div>
              <div style={{fontSize:22,fontWeight:900,color:"#f9fafb"}}>Welkom bij Get Home Safe!</div>
              <div style={{fontSize:13,color:"#6b7280",lineHeight:1.7}}>Je vriendinnen ontvangen een uitnodiging.<br/>Jij bent nu beschermd. 💚</div>
              <BigBtn label="Open de app →" onClick={()=>setScreen("home")}/>
            </div>
          )}

          {/* ══ HOME ══ */}
          {screen==="home" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",overflowY:"auto"}}>
              <div style={{padding:"0 18px 12px",borderBottom:"1px solid #1f2937"}}>
                <div style={{fontSize:20,fontWeight:900,color:"#f9fafb",letterSpacing:"-0.5px"}}>🛡️ Get Home Safe</div>
                <div style={{fontSize:11,color:"#6b7280",marginTop:1}}>Nooit meer alleen onderweg</div>
              </div>
              <div style={{flex:1,padding:"14px 16px",display:"flex",flexDirection:"column",gap:12}}>

                {/* kaart */}
                <div style={{borderRadius:14,overflow:"hidden",height:130,position:"relative",background:"linear-gradient(135deg,#1a2744,#0f172a)",border:"1px solid #1f2937"}}>
                  <div style={{position:"absolute",inset:0,backgroundImage:"linear-gradient(rgba(99,102,241,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(99,102,241,.06) 1px,transparent 1px)",backgroundSize:"24px 24px"}}/>
                  <div style={{position:"absolute",top:"44%",left:0,right:0,height:2,background:"rgba(99,102,241,.15)"}}/>
                  <div style={{position:"absolute",top:0,bottom:0,left:"52%",width:2,background:"rgba(99,102,241,.15)"}}/>
                  <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                    <div style={{width:22,height:22,borderRadius:"50% 50% 50% 0",background:"#6366f1",transform:"rotate(-45deg)",border:"3px solid #818cf8",boxShadow:"0 0 14px rgba(99,102,241,.6)"}}/>
                    <div style={{fontSize:8,color:"#a5b4fc",fontWeight:700,background:"rgba(17,24,39,.85)",padding:"2px 6px",borderRadius:4}}>Jouw locatie</div>
                  </div>
                  {/* 3km cirkel */}
                  <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:90,height:90,borderRadius:"50%",border:"1px dashed rgba(99,102,241,.2)",pointerEvents:"none"}}/>
                  <div style={{position:"absolute",bottom:7,left:9,display:"flex",alignItems:"center",gap:4,background:"rgba(17,24,39,.85)",padding:"3px 8px",borderRadius:7}}>
                    <PulsingDot color={gpsStatus==="active"?"#22c55e":gpsStatus==="denied"?"#ef4444":"#fbbf24"}/>
                    <span style={{fontSize:9,color:"#a5b4fc",fontWeight:600}}>
                      {gpsStatus==="active"?"GPS actief":gpsStatus==="denied"?"GPS geweigerd":"GPS laden..."}
                    </span>
                  </div>
                  <div style={{position:"absolute",bottom:7,right:9,background:"rgba(220,38,38,.15)",border:"1px solid rgba(220,38,38,.3)",padding:"2px 7px",borderRadius:6}}>
                    <span style={{fontSize:9,color:"#f87171",fontWeight:700}}>⚠ 1 melding 3km</span>
                  </div>
                </div>

                {/* vriendinnen */}
                <div>
                  <div style={{fontSize:10,fontWeight:700,color:"#374151",textTransform:"uppercase",letterSpacing:1.5,marginBottom:7}}>Vriendinnen</div>
                  <div style={{display:"flex",gap:7}}>
                    {friendsList.map(f=>(
                      <div key={f.name} style={{flex:1,background:"#1a2235",borderRadius:11,padding:"8px",display:"flex",alignItems:"center",gap:6,border:"1px solid #2d3748"}}>
                        <div style={{width:26,height:26,borderRadius:"50%",background:f.geslacht==="man"?"linear-gradient(135deg,#1e3a8a,#2563eb)":"linear-gradient(135deg,#9d174d,#ec4899)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:11,color:"white",flexShrink:0}}>{f.avatar}</div>
                        <div>
                          <div style={{fontSize:11,fontWeight:600,color:"#e5e7eb"}}>{f.name}</div>
                          <div style={{display:"flex",alignItems:"center",gap:2,marginTop:1}}>
                            <div style={{width:5,height:5,borderRadius:"50%",background:onlineUserIds.includes(f.id)?"#22c55e":"#374151"}}/>
                            <span style={{fontSize:9,color:onlineUserIds.includes(f.id)?"#6ee7b7":"#4b5563"}}>{onlineUserIds.includes(f.id)?"Online":"Offline"}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* noodknop */}
                <button onClick={()=>{setScreen("alert");startAlarm();}} style={{width:"100%",background:"linear-gradient(135deg,#dc2626,#b91c1c)",border:"none",borderRadius:14,padding:"14px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:10,boxShadow:"0 8px 22px rgba(220,38,38,.3)"}}>
                  <span style={{fontSize:18}}>🚨</span>
                  <span style={{fontSize:14,fontWeight:900,color:"white"}}>IK VOEL ME ONVEILIG</span>
                </button>

                {/* grid knoppen */}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                  <button onClick={()=>setScreen("police")} style={{background:"#1e3a5f",border:"1px solid #2563eb",borderRadius:11,padding:"11px 6px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:4,color:"#93c5fd",fontSize:10,fontWeight:700}}>
                    <span style={{fontSize:17}}>👮</span>112
                  </button>
                  <button onClick={()=>{setScreen("shared"); if(socketRef.current) socketRef.current.emit("share_location", {lat:gpsLat, lng:gpsLng, address:gpsAddress});}} style={{background:"#1a3325",border:"1px solid #16a34a",borderRadius:11,padding:"11px 6px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:4,color:"#86efac",fontSize:10,fontWeight:700}}>
                    <span style={{fontSize:17}}>📍</span>Locatie
                  </button>
                  <button onClick={goSafeHome} style={{background:"linear-gradient(135deg,#14532d,#166534)",border:"1px solid #22c55e",borderRadius:11,padding:"11px 6px",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:4,color:"#86efac",fontSize:10,fontWeight:700}}>
                    <span style={{fontSize:17}}>🏠</span>Thuis
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ══ TIMER ══ */}
          {screen==="timer" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"8px 20px 20px",gap:12,animation:"fadeUp .4s ease"}}>
              <div style={{fontSize:17,fontWeight:900,color:"#f9fafb"}}>⏱ Tijdklok</div>
              <div style={{fontSize:12,color:"#6b7280",lineHeight:1.6}}>Stel een timer in. Als je niet op tijd checkt sturen we een alarm naar je vriendinnen.</div>

              {timerActive ? (
                <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:20}}>
                  <div style={{width:160,height:160,borderRadius:"50%",background:"rgba(99,102,241,.1)",border:"3px solid #6366f1",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",boxShadow:"0 0 40px rgba(99,102,241,.2)"}}>
                    <div style={{fontSize:36,fontWeight:900,color:"#f9fafb",fontFamily:"monospace"}}>{timerDisplay(timerLeft)}</div>
                    <div style={{fontSize:11,color:"#6b7280",marginTop:4}}>resterend</div>
                  </div>
                  <div style={{background:"rgba(99,102,241,.08)",border:"1px solid rgba(99,102,241,.2)",borderRadius:12,padding:"10px 16px",textAlign:"center"}}>
                    <div style={{fontSize:12,color:"#a5b4fc"}}>Jouw contacten worden gewaarschuwd als de timer afloopt</div>
                  </div>
                  <div style={{display:"flex",flexDirection:"column",gap:8,width:"100%"}}>
                    <BigBtn label="✓ Ik ben veilig — stop timer" onClick={()=>{stopTimer();}} green/>
                    <button onClick={goSafeHome} style={{background:"transparent",border:"1px solid #374151",borderRadius:13,padding:"11px",color:"#6b7280",fontSize:13,fontWeight:700,cursor:"pointer"}}>🏠 Veilig thuis melden</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{fontSize:13,color:"#9ca3af",fontWeight:600}}>Kies tijdsduur:</div>
                  <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                    {[[5,"5 min"],[10,"10 min"],[15,"15 min"],[20,"20 min"],[30,"30 min"],[45,"45 min"]].map(([m,l])=>(
                      <button key={m} onClick={()=>startTimer(m)} style={{background:"#151e2e",border:"1px solid #374151",borderRadius:12,padding:"14px",color:"#f9fafb",fontSize:14,fontWeight:700,cursor:"pointer",textAlign:"center"}}>
                        {l}
                      </button>
                    ))}
                  </div>
                  <div style={{background:"rgba(251,191,36,.08)",border:"1px solid rgba(251,191,36,.2)",borderRadius:12,padding:"11px 13px"}}>
                    <div style={{fontSize:12,color:"#fde68a",lineHeight:1.6}}>💡 Tip: start de timer als je alleen onderweg bent. Je vriendinnen krijgen automatisch een melding als je niet op tijd incheckt.</div>
                  </div>
                </>
              )}
            </div>
          )}

          {/* ══ TIMER VERLOPEN ══ */}
          {screen==="timerExpired" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"24px",gap:16,textAlign:"center",animation:"fadeUp .4s ease"}}>
              <div style={{fontSize:56,animation:"sosPulse 1s ease infinite"}}>⏰</div>
              <div style={{fontSize:20,fontWeight:900,color:"#f9fafb"}}>Timer afgelopen!</div>
              <div style={{fontSize:13,color:"#fca5a5",lineHeight:1.7}}>Jouw contacten zijn gewaarschuwd.<br/>Ben je veilig?</div>
              <div style={{display:"flex",flexDirection:"column",gap:8,width:"100%"}}>
                <BigBtn label="✓ Ja, ik ben veilig" onClick={()=>{setScreen("home");setActiveTab("home");}} green/>
                <BigBtn label="🚨 Ik heb hulp nodig" onClick={()=>{setScreen("alert");startAlarm();}} red/>
              </div>
            </div>
          )}

          {/* ══ NEP-TELEFOONTJE ══ */}
          {screen==="fakeCall" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"8px 20px 20px",gap:12,animation:"fadeUp .4s ease"}}>
              <div style={{fontSize:17,fontWeight:900,color:"#f9fafb"}}>📞 Nep-telefoontje</div>
              <div style={{fontSize:12,color:"#6b7280",lineHeight:1.6}}>Doe alsof je iemand aan de telefoon hebt. Kies wie je "belt" en je telefoon gaat over.</div>
              <div style={{fontSize:12,color:"#9ca3af",fontWeight:700,marginBottom:4}}>Wie belt jou?</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {fakeCalls.map(p=>(
                  <button key={p.name} onClick={()=>startFakeCall(p)} style={{background:"#151e2e",border:"1px solid #374151",borderRadius:13,padding:"14px 16px",cursor:"pointer",display:"flex",alignItems:"center",gap:12,transition:"border-color .2s"}}>
                    <span style={{fontSize:28}}>{p.emoji}</span>
                    <div style={{flex:1,textAlign:"left"}}>
                      <div style={{fontSize:14,fontWeight:700,color:"#f9fafb"}}>{p.name}</div>
                      <div style={{fontSize:11,color:"#6b7280"}}>Gespreksduur ~{p.duration}</div>
                    </div>
                    <span style={{fontSize:18}}>📲</span>
                  </button>
                ))}
              </div>
              <div style={{background:"rgba(99,102,241,.08)",border:"1px solid rgba(99,102,241,.2)",borderRadius:12,padding:"11px 13px",marginTop:4}}>
                <div style={{fontSize:12,color:"#a5b4fc",lineHeight:1.6}}>💡 Tip: gebruik dit als je je ongemakkelijk voelt bij iemand. Doe alsof je gebeld wordt en loop weg.</div>
              </div>
            </div>
          )}

          {/* ══ IN DE BUURT ══ */}
          {screen==="nearby" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"8px 20px 20px",gap:12,animation:"fadeUp .4s ease"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{fontSize:17,fontWeight:900,color:"#f9fafb"}}>📡 In de buurt</div>
                <div style={{display:"flex",alignItems:"center",gap:5,background:"rgba(220,38,38,.1)",border:"1px solid rgba(220,38,38,.25)",borderRadius:8,padding:"3px 9px"}}>
                  <div style={{width:6,height:6,borderRadius:"50%",background:"#ef4444",animation:"ping 1.5s ease infinite"}}/>
                  <span style={{fontSize:10,color:"#f87171",fontWeight:700}}>Live</span>
                </div>
              </div>
              <div style={{fontSize:12,color:"#6b7280",lineHeight:1.6}}>Meldingen van andere GetHomeSafe gebruikers binnen 3 km van jou.</div>

              <div style={{background:"rgba(220,38,38,.06)",border:"1px solid rgba(220,38,38,.15)",borderRadius:13,padding:"12px"}}>
                <div style={{fontSize:11,color:"#f87171",fontWeight:700,marginBottom:8,textTransform:"uppercase",letterSpacing:.8}}>⚠ Actieve meldingen</div>
                {nearbyAlerts.map(a=>(
                  <div key={a.id} style={{background:"#1a0f0f",border:"1px solid rgba(220,38,38,.2)",borderRadius:10,padding:"10px 12px",marginBottom:7}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:16}}>🚨</span>
                        <div>
                          <div style={{fontSize:12,fontWeight:700,color:"#f9fafb"}}>{a.area}</div>
                          <div style={{fontSize:10,color:"#6b7280"}}>{a.dist} · {a.time}</div>
                        </div>
                      </div>
                      <div style={{width:8,height:8,borderRadius:"50%",background:"#ef4444",animation:"ping 1.5s ease infinite"}}/>
                    </div>
                  </div>
                ))}
              </div>



              <div style={{background:"rgba(99,102,241,.08)",border:"1px solid rgba(99,102,241,.2)",borderRadius:12,padding:"11px 13px"}}>
                <div style={{fontSize:12,color:"#a5b4fc",lineHeight:1.6}}>💡 Jij bent ook zichtbaar voor anderen als jij een alarm activeert. Jouw naam wordt nooit getoond — alleen je locatie.</div>
              </div>
            </div>
          )}

          {/* ══ KAART ══ */}
          {screen==="map" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"8px 20px 20px",gap:12,animation:"fadeUp .4s ease",overflowY:"auto"}}>
              <div style={{fontSize:17,fontWeight:900,color:"#f9fafb"}}>🗺️ Groepslocaties</div>
              
              {/* Leaflet kaart met alle markers */}
              <div style={{flex:1,minHeight:300,background:"#151e2e",border:"1px solid #2d3748",borderRadius:16,overflow:"hidden",position:"relative"}}>
                {gpsLat && gpsLng && leafletLoaded ? (
                  <div id="leaflet-map" style={{width:"100%",height:"100%",minHeight:300}}/>
                ) : (
                  <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%",minHeight:300,color:"#6b7280"}}>
                    {!leafletLoaded ? "🗺️ Kaart laden..." : "📍 GPS locatie wordt geladen..."}
                  </div>
                )}
                {/* Online indicator */}
                <div style={{position:"absolute",top:8,right:8,background:"rgba(0,0,0,0.8)",borderRadius:8,padding:"6px 10px",zIndex:1000}}>
                  <div style={{fontSize:10,color:"#22c55e",fontWeight:700}}>📍 {groupLocations.length + 1} online</div>
                </div>
              </div>
              
              {/* Locatie lijst */}
              <div style={{fontSize:12,color:"#6b7280",fontWeight:700,textTransform:"uppercase",letterSpacing:.8}}>Live locaties</div>
              
              {/* Jouw locatie */}
              <div style={{background:"rgba(34,197,94,.1)",border:"1px solid rgba(34,197,94,.3)",borderRadius:12,padding:"12px 14px",display:"flex",alignItems:"center",gap:12}}>
                <div style={{width:38,height:38,borderRadius:"50%",background:T.gradient,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:14,color:"white"}}>
                  {profileName?.charAt(0)?.toUpperCase() || "?"}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:"#f9fafb"}}>📍 Jij</div>
                  <div style={{fontSize:11,color:"#9ca3af"}}>{gpsAddress || "Locatie ophalen..."}</div>
                </div>
                <PulsingDot color="#22c55e"/>
              </div>
              
              {/* Groepsleden locaties */}
              {groupLocations.length > 0 ? (
                groupLocations.map(loc => (
                  <div key={loc.oderId} style={{background:"#151e2e",border:"1px solid #2d3748",borderRadius:12,padding:"12px 14px",display:"flex",alignItems:"center",gap:12}}>
                    <div style={{width:38,height:38,borderRadius:"50%",background:"linear-gradient(135deg,#6366f1,#8b5cf6)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:14,color:"white"}}>
                      {loc.naam?.charAt(0)?.toUpperCase() || "?"}
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:700,color:"#f9fafb"}}>{loc.naam}</div>
                      <div style={{fontSize:11,color:"#9ca3af"}}>{loc.address || `${loc.lat?.toFixed(4)}, ${loc.lng?.toFixed(4)}`}</div>
                      <div style={{fontSize:10,color:"#4b5563"}}>{loc.timestamp ? new Date(loc.timestamp).toLocaleTimeString() : ""}</div>
                    </div>
                    <button
                      onClick={() => window.open(`https://www.google.com/maps/dir/?api=1&destination=${loc.lat},${loc.lng}`, "_blank")}
                      style={{background:"rgba(99,102,241,.15)",border:"1px solid rgba(99,102,241,.3)",borderRadius:8,padding:"8px 12px",color:"#a5b4fc",fontSize:11,fontWeight:700,cursor:"pointer"}}
                    >
                      🧭 Route
                    </button>
                  </div>
                ))
              ) : (
                <div style={{background:"#151e2e",border:"1px solid #2d3748",borderRadius:12,padding:"16px",textAlign:"center"}}>
                  <div style={{fontSize:13,color:"#6b7280"}}>Geen groepsleden online</div>
                  <div style={{fontSize:11,color:"#4b5563",marginTop:4}}>Locaties verschijnen hier als je vrienden online zijn</div>
                </div>
              )}
              
              <div style={{background:"rgba(251,191,36,.08)",border:"1px solid rgba(251,191,36,.2)",borderRadius:12,padding:"11px 13px"}}>
                <div style={{fontSize:12,color:"#fde68a",lineHeight:1.6}}>💡 Tip: klik op een marker voor details. Klik op "Route" om naar een vriend te navigeren.</div>
              </div>
            </div>
          )}

          {/* ══ PROFIEL ══ */}
          {screen==="profile" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",padding:"8px 20px 20px",gap:12,animation:"fadeUp .4s ease",overflowY:"auto"}}>
              <div style={{fontSize:17,fontWeight:900,color:"#f9fafb"}}>👤 Mijn profiel</div>

              <div style={{display:"flex",alignItems:"center",gap:14,background:"#151e2e",border:"1px solid #2d3748",borderRadius:16,padding:"16px"}}>
                <div style={{width:56,height:56,borderRadius:"50%",background:T.gradient,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:900,color:"white",flexShrink:0}}>
                  {profileName.charAt(0).toUpperCase()}
                </div>
                <div style={{flex:1}}>
                  {editProfile
                    ? <input value={profileName} onChange={e=>setProfileName(e.target.value)} style={{...inp,padding:"8px 10px",marginBottom:4}} autoFocus/>
                    : <div style={{fontSize:16,fontWeight:800,color:"#f9fafb"}}>{profileName}</div>
                  }
                  <div style={{fontSize:11,color:"#6b7280",marginTop:2}}>Groep abonnement · Actief</div>
                </div>
                <button onClick={()=>setEditProfile(!editProfile)} style={{background:"rgba(99,102,241,.15)",border:"1px solid rgba(99,102,241,.3)",borderRadius:9,padding:"6px 10px",color:"#a5b4fc",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                  {editProfile?"✓ Opslaan":"✏ Edit"}
                </button>
              </div>

              {/* ── GROEPSCODE KAART ── */}
              <div style={{background:"rgba(99,102,241,.08)",border:"1px solid rgba(99,102,241,.2)",borderRadius:14,padding:"14px 16px",marginBottom:4}}>
                <div style={{fontSize:11,fontWeight:800,color:"#a5b4fc",textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>🔑 Jouw Groepscode</div>
                {groepscode ? (
                  <>
                    <div style={{background:"#0d1117",border:"1px solid #374151",borderRadius:10,padding:"11px 14px",textAlign:"center",marginBottom:10}}>
                      <div style={{fontSize:22,fontWeight:900,color:"#f9fafb",letterSpacing:4,fontFamily:"monospace"}}>{groepscode}</div>
                    </div>
                    <div style={{fontSize:11,color:"#6b7280",marginBottom:10,lineHeight:1.6}}>Deel deze code met maximaal 5 vrienden — zij kunnen gratis aanmelden.</div>
                    <div style={{display:"flex",gap:7}}>
                      <button
                        onClick={()=>navigator.clipboard.writeText(groepscode)}
                        style={{flex:1,background:"rgba(99,102,241,.15)",border:"1px solid rgba(99,102,241,.3)",borderRadius:9,padding:"9px",color:"#a5b4fc",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                        📋 Kopieer code
                      </button>
                      <button
                        onClick={()=>{
                          const tekst = `Ik gebruik GetHomeSafe voor mijn veiligheid 🛡️ Gebruik mijn code ${groepscode} om gratis mee te doen! Download op gethomesafe.nl`;
                          if(navigator.share) navigator.share({title:"GetHomeSafe", text:tekst});
                          else navigator.clipboard.writeText(tekst);
                        }}
                        style={{flex:1,background:"rgba(34,197,94,.08)",border:"1px solid rgba(34,197,94,.2)",borderRadius:9,padding:"9px",color:"#4ade80",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                        📤 Deel via WhatsApp
                      </button>
                    </div>
                  </>
                ) : (
                  <button
                    onClick={async ()=>{
                      try {
                        const d = await api("/api/groep/code", {method:"POST"});
                        if(d.code) setGroepscode(d.code);
                      } catch(err) { setApiError(err.message); }
                    }}
                    style={{width:"100%",background:"rgba(99,102,241,.15)",border:"1px solid rgba(99,102,241,.3)",borderRadius:9,padding:"11px",color:"#a5b4fc",fontSize:13,fontWeight:700,cursor:"pointer"}}>
                    🔑 Genereer mijn groepscode
                  </button>
                )}
              </div>

              <div style={{fontSize:12,color:"#6b7280",fontWeight:700,textTransform:"uppercase",letterSpacing:.8}}>Mijn vriendinnen</div>
              {friendsList.map(f=>(
                <div key={f.name} style={{background:"#151e2e",border:"1px solid #2d3748",borderRadius:12,padding:"11px 14px",display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:34,height:34,borderRadius:"50%",background:f.geslacht==="man"?"linear-gradient(135deg,#1e3a8a,#2563eb)":"linear-gradient(135deg,#9d174d,#ec4899)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:13,color:"white"}}>{f.avatar}</div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:"#f9fafb"}}>{f.name}</div>
                    <div style={{fontSize:11,color:"#6b7280"}}>{f.phone}</div>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{width:6,height:6,borderRadius:"50%",background:onlineUserIds.includes(f.id)?"#22c55e":"#374151"}}/>
                    <span style={{fontSize:10,color:onlineUserIds.includes(f.id)?"#6ee7b7":"#4b5563"}}>{onlineUserIds.includes(f.id)?"Online":"Offline"}</span>
                  </div>
                </div>
              ))}

              <div style={{fontSize:12,color:"#6b7280",fontWeight:700,textTransform:"uppercase",letterSpacing:.8,marginTop:4}}>Instellingen</div>
              {[["🔔","Push notificaties","pushNotif"],["📡","3km meldingen","buurtMeld"],["🔒","Privacy modus","privacy"],["🌙","Donker thema","donker"]].map(([ico,label,key])=>(
                <div key={label} style={{background:"#151e2e",border:"1px solid #2d3748",borderRadius:12,padding:"12px 14px",display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:16}}>{ico}</span>
                  <div style={{flex:1,fontSize:13,color:"#f9fafb",fontWeight:600}}>{label}</div>
                  <div onClick={()=>setInstellingen(p=>({...p,[key]:!p[key]}))}
                    style={{width:42,height:24,borderRadius:12,background:instellingen[key]?"#22c55e":"#374151",display:"flex",alignItems:"center",padding:"3px",cursor:"pointer",transition:"background .25s",flexShrink:0}}>
                    <div style={{width:18,height:18,borderRadius:"50%",background:"white",marginLeft:instellingen[key]?18:0,transition:"margin .25s"}}/>
                  </div>
                </div>
              ))}

              <button onClick={logout}
                style={{background:"transparent",border:"1px solid #374151",borderRadius:12,padding:"12px",color:"#6b7280",fontSize:13,fontWeight:700,cursor:"pointer",marginTop:4}}>
                Uitloggen
              </button>
            </div>
          )}

          {/* ══ ALERT ══ */}
          {screen==="alert" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,background:"linear-gradient(180deg,#7f1d1d 0%,#111827 60%)",gap:16,textAlign:"center"}}>
              <div style={{fontSize:52,animation:"sosPulse 1s ease infinite"}}>🚨</div>
              <div>
                <div style={{fontSize:23,fontWeight:900,color:"white"}}>ALARM ACTIEF</div>
                <div style={{fontSize:12,color:"#fca5a5",marginTop:6,lineHeight:1.7}}>Alarm klinkt · Locatie gedeeld<br/>Jouw contacten zijn gewaarschuwd<br/>Gebruikers binnen 3km zijn gewaarschuwd</div>
              </div>
              <div style={{background:"rgba(255,255,255,.05)",borderRadius:12,padding:"11px 14px",fontSize:12,color:"#fca5a5",lineHeight:1.7,width:"100%",textAlign:"left"}}>
                <div style={{fontWeight:700,color:"white",marginBottom:2}}>📍 Jouw locatie:</div>
                {gpsStatus==="active"
                  ? <>{gpsAddress}<br/><span style={{fontSize:10,color:"#6b7280"}}>{gpsLat?.toFixed(5)}, {gpsLng?.toFixed(5)}</span></>
                  : gpsStatus==="denied" ? "⚠️ GPS geweigerd — sta locatie toe in je browser" : "Locatie ophalen..."}
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:7,width:"100%"}}>
                <button onClick={()=>setScreen("police")} style={{width:"100%",background:"#1e3a5f",border:"1px solid #2563eb",borderRadius:12,padding:"11px",color:"#93c5fd",fontSize:13,fontWeight:700,cursor:"pointer"}}>👮 Bel politie 112</button>
                <button onClick={goHome} style={{background:"transparent",border:"1px solid #374151",borderRadius:12,padding:"10px",color:"#6b7280",fontSize:12,fontWeight:700,cursor:"pointer"}}>Alarm stoppen — ik ben veilig</button>
              </div>
            </div>
          )}

          {/* ══ POLICE ══ */}
          {screen==="police" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,gap:14,textAlign:"center"}}>
              <div style={{fontSize:50}}>🚔</div>
              <div style={{background:"#1e3a5f",border:"2px solid #2563eb",borderRadius:16,padding:"18px 28px",display:"flex",flexDirection:"column",alignItems:"center",gap:7,width:"100%"}}>
                <div style={{fontSize:11,color:"#93c5fd",fontWeight:600}}>Politie / Brandweer / Ambulance</div>
                <div style={{fontSize:44,fontWeight:900,color:"#93c5fd",letterSpacing:4}}>1-1-2</div>
              </div>
              <div style={{fontSize:12,color:"#6b7280",lineHeight:1.6}}>Geef dit door:<br/><strong style={{color:"#e5e7eb"}}>{gpsStatus==="active"?gpsAddress:"Locatie ophalen..."}</strong>
                {gpsStatus==="active" && <><br/><span style={{fontSize:10,color:"#4b5563"}}>{gpsLat?.toFixed(5)}, {gpsLng?.toFixed(5)}</span></>}
              </div>
              <div style={{display:"flex",gap:8,width:"100%"}}>
                <a href="tel:112" style={{flex:1,background:"#16a34a",borderRadius:11,padding:"12px",textAlign:"center",color:"white",fontWeight:800,fontSize:13,textDecoration:"none",display:"block"}}>📞 Bellen</a>
                <button onClick={goHome} style={{flex:1,background:"transparent",border:"1px solid #374151",borderRadius:11,padding:"12px",color:"#6b7280",fontWeight:700,fontSize:12,cursor:"pointer"}}>Terug</button>
              </div>
            </div>
          )}

          {/* ══ LOCATIE GEDEELD ══ */}
          {screen==="shared" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,gap:14,textAlign:"center"}}>
              <div style={{width:58,height:58,borderRadius:"50%",background:"linear-gradient(135deg,#16a34a,#15803d)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,boxShadow:"0 0 28px rgba(22,163,74,.4)",animation:"pop .4s ease"}}>✓</div>
              <div>
                <div style={{fontSize:19,fontWeight:900,color:"#f9fafb"}}>Locatie gedeeld!</div>
                <div style={{fontSize:12,color:"#6b7280",marginTop:4,lineHeight:1.7}}>Sara en Lena kunnen<br/>jouw locatie nu zien</div>
              </div>
              <div style={{width:"100%",display:"flex",flexDirection:"column",gap:7}}>
                {friendsList.filter(f=>onlineUserIds.includes(f.id)).map(f=>(
                  <div key={f.name} style={{background:"#1a3325",border:"1px solid #16a34a",borderRadius:11,padding:"9px 13px",display:"flex",alignItems:"center",gap:9}}>
                    <div style={{width:28,height:28,borderRadius:"50%",background:T.gradient,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:11,color:"white"}}>{f.avatar}</div>
                    <div style={{flex:1,textAlign:"left"}}>
                      <div style={{color:"#e5e7eb",fontWeight:600,fontSize:12}}>{f.name}</div>
                      <div style={{color:"#86efac",fontSize:10}}>Ontvangt jouw locatie ✓</div>
                    </div>
                    <span style={{fontSize:14}}>📍</span>
                  </div>
                ))}
              </div>
              <button onClick={goHome} style={{background:"transparent",border:"1px solid #374151",borderRadius:12,padding:"11px 22px",color:"#6b7280",fontSize:12,fontWeight:700,cursor:"pointer"}}>Terug naar home</button>
            </div>
          )}

          {/* ══ VEILIG THUIS ══ */}
          {screen==="safeHome" && (
            <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"22px 20px",gap:14,background:"linear-gradient(180deg,#052e16 0%,#111827 60%)",textAlign:"center",animation:"fadeUp .4s ease"}}>
              <div style={{fontSize:56,animation:"pop .5s ease"}}>🏠</div>
              <div>
                <div style={{fontSize:20,fontWeight:900,color:"#4ade80"}}>Veilig thuis! 🎉</div>
                <div style={{fontSize:12,color:"#6b7280",marginTop:6,lineHeight:1.7}}>Aankomst om <strong style={{color:"#e5e7eb"}}>{safeHomeTime}</strong><br/>Vriendinnen zijn op de hoogte</div>
              </div>
              <div style={{width:"100%",display:"flex",flexDirection:"column",gap:6}}>
                {friendsList.filter(f=>onlineUserIds.includes(f.id)).map(f=>(
                  <div key={f.name} style={{background:"rgba(34,197,94,.07)",border:"1px solid rgba(34,197,94,.2)",borderRadius:11,padding:"9px 13px",display:"flex",alignItems:"center",gap:9}}>
                    <div style={{width:26,height:26,borderRadius:"50%",background:T.gradient,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:11,color:"white"}}>{f.avatar}</div>
                    <div style={{flex:1,textAlign:"left"}}>
                      <div style={{color:"#e5e7eb",fontWeight:600,fontSize:12}}>{f.name}</div>
                      <div style={{color:"#4ade80",fontSize:10}}>✓ Bericht ontvangen</div>
                    </div>
                    <span style={{fontSize:13}}>💬</span>
                  </div>
                ))}
              </div>
              <button onClick={goHome} style={{width:"100%",background:"linear-gradient(135deg,#14532d,#166534)",border:"2px solid #22c55e",borderRadius:13,padding:"13px",color:"#86efac",fontSize:13,fontWeight:800,cursor:"pointer"}}>↩ Terug naar home</button>
            </div>
          )}

          {showNav && <BottomNav/>}
        </div>
      </div>
    </>
  );
}
